import React, { useState } from "react";

export default function TextForm(props) {

 const handleUpperCase = ()=>{
    let newText = text.toLocaleUpperCase(); 
    setText (newText)
    props.showAlert ("Converted to Upper Case ! "  , "success")
 }
 const handleLowerCase = ()=>{
    let newText = text.toLocaleLowerCase(); 
    setText (newText)
    props.showAlert ("Converted to Lower Case ! "  , "success")
 }
 const handleSentenceCase = ()=>{
    let newText = text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
    setText (newText)
    props.showAlert ("Converted to Sentence !"  , "success")
 }
 const handleRemove = () => {
    let newText = text.replace(/\s{2,}/g, ' ').trim() 
    setText(newText)
    props.showAlert ("Remove Extra spaces !"  , "success")
 }
 
 const handleCapitalize = () => {
    let newText = text.split(" ").map(el => el.charAt(0).toUpperCase() + el.slice(1)).join(" ");
    setText(newText);
    props.showAlert ("Converted to Capitalize !"  , "success")
}

 const handleClear = ()=>{
    let newText = ""
    setText(newText)
    props.showAlert ("Clear all text !"  , "success")
 }

 const handleCopyText = () => {
    navigator.clipboard.writeText(text);
    
    props.showAlert ("Copied all text !"  , "success")
    
}

 const handleOnChange = (e)=>{
    setText(e.target.value)
 }

  const [text, setText] = useState("");
  return (
    <>
      <div className="container" style={{color : props.mode === "dark" ? "white" : 'black'}}>
        <h1>{props.heading} </h1>
        <div className="mb-3">
          <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor : props.mode === "dark" ? "#202124" : 'white',color : props.mode === "dark" ? "white" : 'black'}} id="myBox" rows="10"></textarea>
          </div>
          <div className="responsive">
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleUpperCase}>Uppercase</button>
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleLowerCase}> Lowercase</button>
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleSentenceCase}>Convert to Sentence </button>
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleRemove}>Remove Extra Spaces </button>
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleCapitalize}>Capitalize</button>
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleCopyText}>Copy Text</button>
            <button disabled = {text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleClear}>Clear Text</button>
          </div>
      </div>
      <div className="container my-3" style={{color : props.mode === "dark" ? "white" : 'black'}}>
        <h2>Text summary</h2>
        <p>{text.split(' ').filter((element)=>{return element.length!==0}).length} words and {text.length} characters</p>
        <p>{0.008*text.split(' ').length} Minutes read </p>
        <h2>Preview Text</h2>
        <p>{text.length > 0 ? text: "Enter something to preview it here."} </p>
      </div>
      </>
  );
}
